





































import {Component, Vue} from 'vue-property-decorator';
import AsideItem, {AsideMenuItem} from '@/layouts/back-office/aside/AsideItem.vue';
import IconLogout from '@/layouts/back-office/icons/Logout.vue';
import IconMenu from '@/layouts/back-office/icons/Menu.vue';
import md5 from 'md5';
import Spinner from '@/layouts/back-office/elements/Spinner.vue';
import Logo from '@/layouts/back-office/icons/Logo.vue';
import ActionMenu, {
  ActionMenuDirection,
  ActionMenuItem,
  ActionMenuType,
} from '@/layouts/back-office/elements/ActionMenu.vue';
import {IntradorRouteConfig, namedRoutes} from '@/router/router';
import routes from '@/router/routes';
import {MenuPosition} from '@/layouts/back-office/aside/MenuPosition';
import {getHomeRouteName} from '@/router/Fallback';
import RequestDemoForUserModal from '@/layouts/back-office/aside/RequestDemoForUserModal.vue';
import HelpModal from '@/layouts/back-office/aside/HelpModal.vue';


@Component({
  components: {
    HelpModal,
    RequestDemoForUserModal,
    ActionMenu,
    Logo,
    Spinner,
    AsideItem,
    IconLogout,
    IconMenu,
  },
})
export default class Aside extends Vue {
  private open: boolean = true;

  private accountActionMenuDirection: ActionMenuDirection = ActionMenuDirection.TopLeft;

  private homeRouteName: string = 'home';

  private menuTop: AsideMenuItem[] = [];
  private menuBottom: AsideMenuItem[] = [];

  private switchTo: string | null = null;

  private created() {
    getHomeRouteName()
      .then((name: string) => {
        this.homeRouteName = name;
      });

    const menuItems = this.getMenuItems(routes);

    this.menuTop = menuItems.filter((item: AsideMenuItem) => item.menuPosition === MenuPosition.TOP);

    this.menuBottom = menuItems.filter((item: AsideMenuItem) => item.menuPosition === MenuPosition.BOTTOM);

    this.open = localStorage.getItem('aside') === 'open';
    this.$emit('aside-changed', this.open);
  }

  private getMenuItems(iRoutes: IntradorRouteConfig[]): AsideMenuItem[] {
    return namedRoutes.map((route: IntradorRouteConfig) => {
      const title = (typeof route.title === 'function')
        ? route.title()
        : route.title!;

      const item: AsideMenuItem = {
        name: route.name,
        icon: route.icon!,
        title,
        permission: route.permission,
        menuPosition: route.menuPosition,
      };

      return item;
    });
  }

  private getAccountActionMenuItems(account: any): ActionMenuItem[] {
    const accountActionMenuItems: ActionMenuItem[] = [];

    if (this.$can('entity-switch') && account.entities.length > 0) {
      accountActionMenuItems.push({
        label: this.$it('global.user-menu.switch-entity.header', 'Switch entity').toString(),
        type: ActionMenuType.Header,
      });

      account.entities.forEach((entity: any) => {
        if (entity.id !== account.entity.id) {
          accountActionMenuItems.push({
            label: entity.name,
            action: () => {
              this.switchEntity(entity);
            },
          });
        }
      });
    }

    accountActionMenuItems.push({
      label: this.$it('global.user-menu.toolkit.header', 'Tools').toString(),
      type: ActionMenuType.Header,
    });

    accountActionMenuItems.push({
      label: this.$it('global.user-menu.toolkit.request-demo-button', 'Request Demo').toString(),
      action: this.requestDemoForUser,
    });

    if (process.env.VUE_APP_HELP_DOCUMENT_URL) {
      accountActionMenuItems.push({
        label: this.$it('global.user-menu.help.header', 'Help').toString(),
        action: this.askForHelp,
      });
    }

    accountActionMenuItems.push({
      label: this.$it('global.user-menu.user-settings.header', 'User settings').toString(),
      type: ActionMenuType.Header,
    });

    accountActionMenuItems.push({
      label: this.$it('global.logout', 'Logout').toString(),
      action: this.logout,
    });

    return accountActionMenuItems;
  }

  private requestDemoForUser() {
    (this.$refs.requestDemoForUserModal as RequestDemoForUserModal).open();
  }

  private askForHelp() {
    (this.$refs.helpModal as HelpModal).open();
  }

  private switchEntity(entity: any) {
    this.$apollo.mutate({
      mutation: require('@/graphql/mutations/SwitchEntity.graphql'),
      variables: {
        entityId: entity.id,
      },
    }).then(async () => {
      this.switchTo = entity.name;

      await this.$apolloProvider.defaultClient.resetStore();

      // if (this.homeRouteName !== this.$route.name) {
      //   await this.$router.replace({
      //     name: this.homeRouteName,
      //     params: {
      //       lang: this.$route.params.lang,
      //     },
      //   }).catch(() => {
      //     // If there is an error on the page, catch it otherwise the action will not be completed
      //   });
      // } else {
      //   await this.$apolloProvider.defaultClient.reFetchObservableQueries();
      // }

      window.location.href = process.env.VUE_APP_DOMAIN as string;

      this.switchTo = null;
    });
  }

  /**
   * Toggle the menu
   */
  private toggle() {
    this.open = !this.open;
    localStorage.setItem('aside', (this.open) ? 'open' : 'closed');
    this.$emit('aside-changed', this.open);
  }

  /**
   * Toggle the menu
   */
  private flows() {
    location.href = '/en-gb/flows';
  }


  /**
   * Logout the user
   */
  private logout() {
    this.$store.dispatch('logout', this.$route.fullPath);
  }

  /**
   * Calculate the avatar URL
   * @param email
   * @return string
   */
  private avatar(email: string) {
    return `https://www.gravatar.com/avatar/${md5(email)}?s=64`;
  }
}
